<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  variant: String,
  resize: String,
});

const componentClasses = computed(() => [
  'stk-tabs',
  props.variant ? `is-${props.variant}` : '',
  props.resize ? `stk-resize-${props.resize}` : '',
]);
</script>

<style>
.stk-tabs {
  border-bottom: 1px solid var(--stk-text-80);
  gap: 0.25em;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;

  &.is-fullwidth {
    .stk-tabs-list,
    .stk-tab-item {
      flex-grow: 1;
    }
  }
}

[data-stk-theme="dark"] {
  .stk-tabs {
    background-color: var(--stk-text-20);
  }
}
</style>
